<div class="row" *ngIf="(opportunity | json) != '{}'">
    <div class="col-sm-12">
        <div class="row">
            <div class="col-sm-3">
                <div class="row">
                    <div class="col">
                        <label class="fw-bold">Opportunity Owner</label>
                        <select name="ownerEmployeeId" [(ngModel)]="opportunity.ownerEmployeeId" class="form-select" [ngClass]="(opportunity.ownerEmployeeId==null||opportunity.ownerEmployeeId<=0) ? 'border border-danger' : ''" required>
                            <option *ngFor="let employee of employeeList" value="{{employee.employeeId}}">{{employee.fullName}}</option>
                        </select>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <label class="fw-bold">Opportunity Name</label>
                        <input type="text" class="form-control" [ngClass]="(opportunity.notes==null||opportunity.notes=='') ? 'border border-danger' : ''" [(ngModel)]="opportunity.notes" required />
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <label class="fw-bold">Product</label>
                        <select name="productID" [(ngModel)]="opportunity.productId" class="form-select" [ngClass]="(opportunity.productId==null||opportunity.productId<=0) ? 'border border-danger' : ''" required>
                            <option *ngFor="let product of productList" value="{{product.productId}}">{{product.productName}}</option>
                        </select>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <label class="fw-bold">Sales Cycle</label>
                        <select name="salesCycleID" [(ngModel)]="salesCycleMap.salesCycleId" class="form-select" required disabled>
                            <option *ngFor="let salesCycle of salesCycleList" value="{{salesCycle.salesCycleId}}">[{{salesCycle.abbrev}}] {{salesCycle.description}}</option>
                        </select>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <label class="fw-bold">Due Date</label>
                        <br />
                        <kendo-datepicker name="dueDate"
                                          [ngClass]="opportunity.dueDate==null ? 'border border-danger' : ''"
                                          [(ngModel)]="opportunity.dueDate"
                                          [format]="'MM/dd/yy'"
                                          [ngModelOptions]="{standalone: true}"
                                          (valueChange)="dateChanged('dueDate')"
                                          required>
                        </kendo-datepicker>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <label class="fw-bold">Close Date</label>
                        <br />
                        <kendo-datepicker name="expectedCloseDate"
                                          [ngClass]="opportunity.expectedCloseDate==null ? 'border border-danger' : ''"
                                          [(ngModel)]="opportunity.expectedCloseDate"
                                          [format]="'MM/dd/yy'"
                                          [ngModelOptions]="{standalone: true}"
                                          (valueChange)="dateChanged('expectedCloseDate')"
                                          required>
                        </kendo-datepicker>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <label class="fw-bold">Start Date</label>
                        <br />
                        <kendo-datepicker name="startDate"
                                          [(ngModel)]="opportunity.startDate"
                                          [format]="'MM/dd/yy'"
                                          [ngModelOptions]="{standalone: true}"
                                          (valueChange)="dateChanged('startDate')"
                                          required>
                        </kendo-datepicker>
                    </div>
                </div>
            </div>
            <div class="col-sm-3">
                <div class="row">
                    <div class="col">
                        <label class="fw-bold">Priority</label>
                        <select name="opportunityPriorityID" [(ngModel)]="opportunity.opportunityPriorityID" class="form-select">
                            <option *ngFor="let item of opportunityPriorityList" value="{{item.opportunityPriorityID}}" class="text-{{item.colorClassName}}">{{item.opportunityPriorityName}}</option>
                            <option value="0">NONE</option>
                        </select>
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <label class="fw-bold">Est Net Revenue</label>
                        <input type="number" class="form-control" [ngClass]="(opportunity.estimatedRevenue==null||opportunity.estimatedRevenue<0) ? 'border border-danger' : ''" [(ngModel)]="opportunity.estimatedRevenue" min="0" />
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <label class="fw-bold">Est Gross Revenue</label>
                        <input type="number" class="form-control" [(ngModel)]="opportunity.estimatedGrossRevenue" min="0" />
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <label class="fw-bold">Est Total Annual Orders Count</label>
                        <input type="number" class="form-control" [(ngModel)]="opportunity.estimatedAnnualOrderCount" min="0" />
                    </div>
                </div>
                <div class="row">
                    <div class="col">
                        <label class="fw-bold">Likelihood of Win (eg. enter 0.6 for 60%)</label>
                        <kendo-numerictextbox format="p" [step]="0.01" [min]="0" [max]="1" [value]="opportunity.likelihoodOfWin" [(ngModel)]="opportunity.likelihoodOfWin"></kendo-numerictextbox>
                    </div>
                </div>
            </div>
            <div class="col">
                <kendo-expansionpanel [title]="'Summary'"
                                      [subtitle]="''"
                                      [expanded]="true">
                    <div class="row">
                        <div class="col-sm-4">
                            <div class="row">
                                <div class="col" style="height:49px;">
                                    <br />
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <label class="fw-bold">Bid Gross Rev</label>
                                    <kendo-numerictextbox format="c0" [value]="opportunity.bidAnnualGross" [disabled]="true"></kendo-numerictextbox>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <label class="fw-bold">Bid Cost</label>
                                    <kendo-numerictextbox format="c0" [value]="opportunity.bidAnnualCost" [disabled]="true"></kendo-numerictextbox>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <label class="fw-bold">Bid Net Rev</label>
                                    <kendo-numerictextbox format="c0" [value]="opportunity.bidAnnualNet" [disabled]="true"></kendo-numerictextbox>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <label class="fw-bold">Bid Net/Order</label>
                                    <kendo-numerictextbox format="c0" [value]="opportunity.bidAverageNetPerOrder" [disabled]="true"></kendo-numerictextbox>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <label class="fw-bold">Bid Margin</label>
                                    <kendo-numerictextbox format="p" [value]="opportunity.bidAverageMarginPerOrder" [disabled]="true"></kendo-numerictextbox>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="row">
                                <div class="col">
                                    <label class="fw-bold">Expected Won Annual Orders</label>
                                    <kendo-numerictextbox format="n0" [value]="opportunity.expectedOrderCount" [disabled]="true"></kendo-numerictextbox>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <label class="fw-bold">Expected Won Gross Rev</label>
                                    <kendo-numerictextbox format="c0" [value]="opportunity.expectedAnnualGross" [disabled]="true"></kendo-numerictextbox>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <label class="fw-bold">Expected Won Cost</label>
                                    <kendo-numerictextbox format="c0" [value]="opportunity.expectedAnnualCost" [disabled]="true"></kendo-numerictextbox>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <label class="fw-bold">Expected Won Net Rev</label>
                                    <kendo-numerictextbox format="c0" [value]="opportunity.expectedAnnualNet" [disabled]="true"></kendo-numerictextbox>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <label class="fw-bold">Expected Won Net/Order</label>
                                    <kendo-numerictextbox format="c0" [value]="getOpportunityNetPerOrder('expected')" [disabled]="true"></kendo-numerictextbox>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <label class="fw-bold">Expected Won Margin</label>
                                    <kendo-numerictextbox format="p" [value]="getOpportunityMargin('expected')" [disabled]="true"></kendo-numerictextbox>
                                </div>
                            </div>
                        </div>
                        <div class="col-sm-4">
                            <div class="row">
                                <div class="col">
                                    <label class="fw-bold">Actual Annual Orders</label>
                                    <kendo-numerictextbox format="n0" [value]="opportunity.actualOrderCount" [disabled]="true"></kendo-numerictextbox>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <label class="fw-bold">Actual Gross Rev</label>
                                    <kendo-numerictextbox format="c0" [value]="opportunity.actualAnnualGross" [disabled]="true"></kendo-numerictextbox>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <label class="fw-bold">Actual Cost</label>
                                    <kendo-numerictextbox format="c0" [value]="opportunity.actualAnnualCost" [disabled]="true"></kendo-numerictextbox>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <label class="fw-bold">Actual Net Rev</label>
                                    <kendo-numerictextbox format="c0" [value]="opportunity.actualAnnualNet" [disabled]="true"></kendo-numerictextbox>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <label class="fw-bold">Actual Net/Order</label>
                                    <kendo-numerictextbox format="c0" [value]="getOpportunityNetPerOrder('actual')" [disabled]="true"></kendo-numerictextbox>
                                </div>
                            </div>
                            <div class="row">
                                <div class="col">
                                    <label class="fw-bold">Actual Margin</label>
                                    <kendo-numerictextbox format="p" [value]="getOpportunityMargin('actual')" [disabled]="true"></kendo-numerictextbox>
                                </div>
                            </div>
                        </div>
                    </div>
                </kendo-expansionpanel>
            </div>
        </div>
        <div class="row">
            <div class="col m-2 text-end">
                <button class="btn btn-primary m-2" (click)="save()" [disabled]="!isValid()">Save</button>
                <!--<button class="btn btn-secondary m-2" (click)="cancel()">Cancel</button>-->
            </div>
        </div>
    </div>
</div>
